import React, { FC } from 'react'
import { rem } from 'polished'
import styled from 'styled-components'
import Header from 'supportAssistant/components/Support/Header'
import { mediaQueryUp } from 'components/utils/breakpoint'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import shouldRenderWhatsApp from 'lib/whatsApp'
import config from 'constants/config'
import SolidWhatsappIcon from 'components/Luxkit/Icons/solid/SolidWhatsappIcon'
import { getImageUrl } from 'lib/imageUtils'
import TextLink from 'components/Luxkit/TextLink'
import { connect } from 'react-redux'
import { getSupportContact } from 'selectors/supportContactSelector'

const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: ${rem(60)} auto;
  height: 100%;
  width: 100%;
  min-width: ${rem(232)};
  background-color: ${({ theme }) => theme.palette.neutral.eight};

  ${mediaQueryUp.md} {
    min-width: ${rem(280)};
  }
`

const SupportContact = styled.div`
  display: grid;
  grid-auto-rows: min-content;
  grid-gap: ${rem(24)};
  padding: ${rem(24)};
`

const StyledTeamDiv = styled.div`
  display: grid;
  grid-gap: ${rem(8)};
  margin-top: ${rem(40)};
  margin-bottom: ${rem(16)};
`

const Contacts = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${rem(16)};
`

const StyledImage = styled.img`
  object-fit: cover;
  object-position: center;
  margin: auto;
  margin-bottom: ${rem(8)};
  width: ${rem(70)};
  height: ${rem(70)};
  border-radius: ${props => props.theme.borderRadius.round};
`

interface Props {
  currentContact: App.GeoContacts;
  currentRegionCode: string;
}

const Support: FC = ({
  currentContact,
  currentRegionCode,
}: Props) => {
  const isIndiaRegion = currentRegionCode === 'IN'

  const defaultContact = currentContact[currentContact.default]
  const contactTagLine = isIndiaRegion ? 'Call us 7 days' : 'Call us 24 hours, 7 days'

  const imageUrl = getImageUrl('d5sfjdbpg47k0yfcxxzj', {
    width: 69,
    height: 69,
    format: 'jpg',
    quality: 'best',
    highRes: true,
  })

  return (
    <Container>
      <Header />
      <SupportContact>
        <StyledTeamDiv>
          <StyledImage src={imageUrl} />
          <Heading variant="heading5" align="center">
            Our team is available <br />
            24 hours, 7 days
          </Heading>
          <BodyText variant="large" align="center">
            Need to talk to our team? Call our customer service team anytime, whenever you need us.
          </BodyText>
        </StyledTeamDiv>
        <Contacts>
          <TextLink
            href={`tel:${defaultContact.number}`}
            aria-label={contactTagLine + 'contact us'}
            size="large"
            startIcon={<LinePhoneIcon />}
            weight="regular"
          >
            {defaultContact.humanReadable}
          </TextLink>
          {shouldRenderWhatsApp(currentRegionCode) &&
            <TextLink
              to={`https://wa.me/${config.WHATS_APP_NUMBER}`}
              startIcon={<SolidWhatsappIcon colour="success" />}
              size="large"
              underline={false}
              weight="regular"
            >
              WhatsApp
            </TextLink>
          }
        </Contacts>
      </SupportContact>
    </Container>
  )
}

function mapStateToProps(state: App.State) {
  return {
    currentContact: getSupportContact(state),
    currentRegionCode: state.geo.currentRegionCode,
  }
}

export default connect(mapStateToProps)(Support)
